import {identity} from 'lodash';
import {useMemo} from 'react';
import urlparam from 'urlparam';

export function useIdListFromQueryString(paramName) {
    const paramValue = urlparam(paramName) || '';
    return useMemo(() => {
        return paramValue
            .toString()
            .split(',')
            .map(id => parseInt(id, 10))
            .filter(identity);
    }, [paramValue]);
}
